export default "/assets/website/images/chocho_mobile_bg.webp?d009e18798df3dc3d46c68ca5bb445bd";